import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { ShieldAlert, ArrowLeft, Home } from 'lucide-react';
import { Link, useNavigate } from 'react-router';

export const AdminNotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section className='flex flex-col items-center justify-center gap-8 py-16 text-center sm:py-20'>
      <Badge variant='outline' className='border-swd-tuerkis text-swd-tuerkis-darker'>
        Admin Bereich
      </Badge>
      <Card className='w-full max-w-3xl border-neutral-hellgrau shadow-sm'>
        <CardHeader className='space-y-6'>
          <div className='mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-swd-hellblau text-swd-tuerkis-darker'>
            <ShieldAlert className='h-8 w-8' aria-hidden='true' />
          </div>
          <CardTitle className='text-3xl font-semibold tracking-tight text-swd-tuerkis-darker sm:text-4xl'>
            Seite nicht gefunden
          </CardTitle>
          <CardDescription className='text-base leading-6 text-neutral-grau'>
            Die von Ihnen angeforderte Admin-Seite existiert nicht oder wurde verschoben. Nutzen Sie die folgenden
            Optionen, um schnell wieder zu den bekannten Bereichen zu gelangen.
          </CardDescription>
        </CardHeader>
        <CardContent className='flex flex-col items-center gap-6'>
          <div className='flex w-full flex-col gap-3 sm:flex-row sm:justify-center'>
            <Button variant='outline' onClick={() => navigate(-1)} className='w-full sm:w-auto'>
              <ArrowLeft className='mr-2 h-4 w-4' aria-hidden='true' /> Zurück zur letzten Seite
            </Button>
            <Button asChild className='w-full sm:w-auto'>
              <Link to='/admin'>
                <Home className='mr-2 h-4 w-4' aria-hidden='true' /> Zur Admin-Übersicht
              </Link>
            </Button>
          </div>
          <div className='space-y-2 text-left text-sm text-muted-foreground'>
            <p className='font-medium text-neutral-dunkelgrau'>Schnelle Navigation</p>
            <div className='grid gap-2 sm:grid-cols-2'>
              <Button asChild variant='ghost' className='justify-start text-foreground'>
                <Link to='/admin/vouchers'>Gutscheinverwaltung öffnen</Link>
              </Button>
              <Button asChild variant='ghost' className='justify-start text-foreground'>
                <Link to='/admin/providers'>Partnerübersicht anzeigen</Link>
              </Button>
              <Button asChild variant='ghost' className='justify-start text-foreground'>
                <Link to='/admin/balance'>Budgets verwalten</Link>
              </Button>
              <Button asChild variant='ghost' className='justify-start text-foreground'>
                <Link to='/component-library'>Zur Komponentenbibliothek</Link>
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </section>
  );
};
